export const createHelpConfig = (history,setSelectedItemId) => ({
    isEnabled: true,
    items: [
        {
            title: "help",
            id: "1",
            clickable: {
                type: "button",
                onClick: () => {
                    history.push('/help');
                    setSelectedItemId('');
                    return {
                        preventOverlayClose: false
                    };
                },
            }
        }
    ]
});